import { Reducer, Action } from "redux";
import { KnownAction, IDocumentsAndImagesState, RECEIVE_USER_DOCUMENTS_AND_IMAGES, USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER } from "./types";

export const documentsAndImagesReducer: Reducer<IDocumentsAndImagesState> = (
    state: IDocumentsAndImagesState | undefined,
    incomingAction: Action
): IDocumentsAndImagesState => {
    if (state === undefined) {
        return {
            vaultFileList: [],
            isLoading: false,
            totalFileSize: 0,
        };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_USER_DOCUMENTS_AND_IMAGES:
            return {
                ...state,
                vaultFileList: action.vaultFileList,
                totalFileSize: action.totalFileSize,
            };
        case USER_DOCUMENTS_AND_IMAGES_SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
